<template>
  <div>
    <Main />
  </div>
</template>

<script>
import Main from "../../canads/casas/maplocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
};
</script>
